export const FETCH_NETWORKS_DATA = 'SERVICES/FETCH_NETWORKS_DATA'
export const SET_LOADING = 'SERVICES/SET_LOADING'
export const SET_NETWORKS_LIST = 'SERVICES/SET_NETWORKS_LIST'
export const FETCH_ADVERTISING_TYPES = 'SERVICES/FETCH_ADVERTISING_TYPES'
export const SET_ADVERTISING_TYPES = 'SERVICES/SET_ADVERTISING_TYPES'
export const MAIN_FILTERS_APPLY = 'SERVICES/MAIN_FILTERS_APPLY'
export const SET_FILTERS = 'SERVICES/SET_FILTERS'
